import { memo as Memo } from 'react';

//* Components
import Text from 'components/common/Text';

//* Style
import RolesStyle from './style';

const Roles = Memo(({ className, roles }) => {
	return (
		<RolesStyle className={`${className || ''}`}>
			<div className={`rolesWrap`}>
				<Text
					className={`pS gilroyLight gray44 uppercase`}
					text={`roles`}
				/>
				<div className={`namePositionGlobWrap`}>
					{roles.map((role, ind) => (
						<div
							key={ind}
							className={`namePositionInternalWrap`}>
							<Text
								className={`h6 maisonNeueMedium blackRussian`}
								text={role.name}
							/>
							&nbsp;
							<Text
								className={`h6 maisonNeueMedium blackRussian`}
								text={`/`}
							/>
							&nbsp;
							<Text
								className={`h6 maisonNeueLight blackRussian`}
								text={role.position}
							/>
						</div>
					))}
				</div>
			</div>
		</RolesStyle>
	);
});

export default Roles;
